import './MauticTrialForm.scss'

import React, { FunctionComponent } from 'react'

import TrialFormCS from './TrialForms/TrialFormCS'
import TrialFormDE from './TrialForms/TrialFormDE'
import TrialFormEN from './TrialForms/TrialFormEN'
import TrialFormES from './TrialForms/TrialFormES'
import TrialFormFR from './TrialForms/TrialFormFR'
import TrialFormHU from './TrialForms/TrialFormHU'
import TrialFormIT from './TrialForms/TrialFormIT'
import TrialFormRU from './TrialForms/TrialFormRU'

const MauticTrialForm: FunctionComponent = () => {
  switch (process.env.LOCALE || `en`) {
    case `hu`:
      return <TrialFormHU />
    case `cs`:
      return <TrialFormCS />
    case `de`:
      return <TrialFormDE />
    case `es`:
      return <TrialFormES />
    case `fr`:
      return <TrialFormFR />
    case `ru`:
      return <TrialFormRU />
    case `it`:
      return <TrialFormIT />
    default:
      return <TrialFormEN />
  }
}

export default MauticTrialForm
